<div *ngIf="loading" class="text-center py-5">
  <span>Loading ID card&hellip;</span>
</div>

<ng-container *ngIf="!loading">
  <div *ngIf="card?.number; else noCard">
    <div class="rounded shadow-sm pt-5 pb-5">
      <div class="card-title m-0 d-flex justify-content-start align-items-center d-none d-md-flex ms-md-9 justify-content-between">
        <div class="d-flex align-items-center">
          <a class="btn btn-dark text-white mb-2 ls-2 px-6" (click)="downloadAsImage()">
            <span class="indicator-label">Download as Image</span>
          </a>
          <a class="btn btn-dark text-white mb-2 ls-2 px-6 ms-3" (click)="downloadAsPdf()">
            <span class="indicator-label">Download as PDF</span>
          </a>
        </div>
        <button type="button" class="btn-close me-md-9" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="aspect-ratio mx-auto">
        <!-- embed=1 marks this as an in-app view (user looking at their own
             card from their account), not a public QR-scan verification.
             The renderer uses it to suppress the green "ID Card Verified"
             banner — that banner is only meaningful when someone else
             scanned the QR and landed on the public verify URL. -->
        <iframe [src]="('/id-card?cardNumber=' + card.number + '&embed=1') | safeHtml:'resourceUrl'"
                id="id-card-div" frameborder="0"></iframe>
      </div>
    </div>
  </div>

  <ng-template #noCard>
    <div class="text-center py-5">
      <i class="fa fa-id-card fs-1 text-muted mb-3"></i>
      <h5>No ID card yet</h5>
      <p class="text-muted">An ID card hasn't been generated for your profile yet.</p>
      <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
    </div>
  </ng-template>
</ng-container>
